import { motion } from "framer-motion";
import { Button } from "@/components/ui/Button";

interface GeneratingStepProps {
  activeCount: number;
  onCancel?: () => void;
}

export function GeneratingStep({ activeCount, onCancel }: GeneratingStepProps) {
  return (
    <div className="animate-reveal mx-auto max-w-2xl py-12 text-center">
      <div className="mb-6 flex justify-center">
        <Spinner />
      </div>
      <h1 className="text-[clamp(2.25rem,4.5vw,3.25rem)] font-medium tracking-tight text-ink">
        Generating your AI1 form
      </h1>
      <p className="mt-4 text-[1.05rem] leading-relaxed text-ink-soft">
        Creating PDF with{" "}
        <span className="font-semibold text-primary">{activeCount}</span>{" "}
        {activeCount === 1 ? "objection" : "objections"}…
      </p>
      {onCancel && (
        <div className="mt-8">
          <Button intent="ghost" size="md" onClick={onCancel}>
            Cancel and go back
          </Button>
        </div>
      )}
    </div>
  );
}

function Spinner() {
  return (
    <motion.div
      animate={{ rotate: 360 }}
      transition={{ duration: 1.4, repeat: Infinity, ease: "linear" }}
      className="relative h-16 w-16"
    >
      <div className="absolute inset-0 rounded-full border-4 border-primary-soft" />
      <div className="absolute inset-0 rounded-full border-4 border-primary border-t-transparent border-r-transparent" />
    </motion.div>
  );
}
